import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import Button from "@components/Button";

interface SocialLoginButtonsProps {
    redirectPath?: string;
    onSuccess?: (user: any) => void;
}

export default function SocialLoginButtons({
    redirectPath = "/need-auth",
    onSuccess
}: SocialLoginButtonsProps) {
    const { loginWithGoogle, loginWithGithub } = useAuth();
    const navigate = useNavigate();

    const handleSocialLogin = async (socialLoginFn: () => Promise<any>) => {
        const user = await socialLoginFn();
        if (user) {
            if (onSuccess) {
                onSuccess(user);
            } else {
                navigate(redirectPath);
            }
        }
    };

    return (
        <>
            <div className="grid grid-cols-2 gap-2">
                <Button
                    type="secondary"
                    onClick={() => handleSocialLogin(loginWithGoogle)}
                    className="!h-auto py-3"
                >
                    <img
                        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                        alt="Google"
                        className="h-4 w-4"
                    />
                    <span>Continue with Google</span>
                </Button>
                <Button
                    type="primary"
                    className="!h-auto !bg-[rgb(70,70,70)] py-3 hover:!bg-[rgb(60,60,60)] hover:!shadow-none"
                    onClick={() => handleSocialLogin(loginWithGithub)}
                >
                    <img
                        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/github.svg"
                        alt="GitHub"
                        className="h-4 w-4"
                    />
                    <span>Continue with GitHub</span>
                </Button>
            </div>
        </>
    );
}
